export default "__VITE_ASSET__BbS2wHi8__"